/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, session: NonNullable<unknown> }} Plan_Build_Removed_LiveInputs */

const en_us2_plan_build_removed_live = /** @type {(inputs: Plan_Build_Removed_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} left ${i?.session}`)
};

const pt_br2_plan_build_removed_live = /** @type {(inputs: Plan_Build_Removed_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} saiu do ${i?.session}`)
};

const es_419_plan_build_removed_live = /** @type {(inputs: Plan_Build_Removed_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} salió de ${i?.session}`)
};

const pt_pt2_plan_build_removed_live = /** @type {(inputs: Plan_Build_Removed_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} saiu do ${i?.session}`)
};

const fr_fr2_plan_build_removed_live = /** @type {(inputs: Plan_Build_Removed_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} a quitté ${i?.session}`)
};

const de_de2_plan_build_removed_live = /** @type {(inputs: Plan_Build_Removed_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} aus ${i?.session} entfernt`)
};

const it_it2_plan_build_removed_live = /** @type {(inputs: Plan_Build_Removed_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} rimosso da ${i?.session}`)
};

/**
* | output |
* | --- |
* | "{name} left {session}" |
*
* @param {Plan_Build_Removed_LiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_removed_live = /** @type {((inputs: Plan_Build_Removed_LiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Removed_LiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_removed_live(inputs)
	if (locale === "es-419") return es_419_plan_build_removed_live(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_removed_live(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_removed_live(inputs)
	if (locale === "de-DE") return de_de2_plan_build_removed_live(inputs)
	if (locale === "it-IT") return it_it2_plan_build_removed_live(inputs)
	return en_us2_plan_build_removed_live(inputs)
});
export { plan_build_removed_live as "plan-build.removed_live" }